exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-shadow[data-v-34f4c571]{box-shadow:3px 3px 10px rgba(25,44,124,.2);border-radius:5px;opacity:1}.btn-see-more[data-v-34f4c571]{color:#000}.btn-see-more[data-v-34f4c571]:hover{background-color:#00a5f5!important;color:#fff!important;border-color:#fff!important;transition:.5s}.over-font-lg[data-v-34f4c571]{font-size:30px;color:#000}.over-font-big[data-v-34f4c571]{font-size:5vw;color:#000}", ""]);

// exports
